/**
 * The workspace page of one subject — `cases/:caseId/humint/subjects/:subjectRef` in
 * `router.tsx`. A subject ref is a graph element id (`4:…:37`), so the segment is encoded.
 */
export function subjectPath(caseId: string, subjectRef: string): string {
  return `/cases/${caseId}/humint/subjects/${encodeURIComponent(subjectRef)}`
}
